import React from "react";
import PageContainer from "../../components/PageContainer/PageContainer";
import Header from "../../components/atoms/Header";
import { useNavigate, useParams } from "react-router-dom";
import ChecklistQuestionAnswerComponent from "../../components/checklist/ChecklistQuestionAnswerComponent";
import { useGetVehicleWithSafetyCheckByIdQuery } from "../../redux/checklistStoreAPI";
import {
  ASafetyCheckWithAnswer,
  ASafetyCheckWithAnswerFormik,
  TYesOrNo,
  //   exampleSafetyCheckList,
} from "../../types/safetycheck";
import { generateQuestionAnswerSafetyCheckArray } from "../../assets/usefulFunctions";
import { Nullable } from "../../types";
import useButtonStyles from "../../hooks/styles/useButtonStyles";
import { combinedRoutes } from "../../config/nav";
import useRoleUser from "../../hooks/auth/useRoleUser";

type Props = {};

const SafetyChecklistInactivePage = (_: Props) => {
  const { id: internal_id } = useParams<"id">();
  const btnClasses = useButtonStyles();
  const role = useRoleUser();
  const {
    data: vehicleDataWithSafetyCheck,
    isLoading,
    isFetching,
  } = useGetVehicleWithSafetyCheckByIdQuery({ internal_id });
  const [initialValues, setInitialValues] =
    React.useState<ASafetyCheckWithAnswerFormik>({ data: [] });
  const navigate = useNavigate();
  const loading = isLoading || isFetching;
  const switchAnswerValue = (value: TYesOrNo): Nullable<TYesOrNo> => {
    switch (value) {
      case "No":
      case "n":
      case "t":
      case "no":
        return "n";
      case "Yes":
      case "yes":
      case "y":
        return "y";
      default:
        return null;
    }
  };

  //   React.useEffect(() => {
  //     let safetyCheckDataAnswers: ASafetyCheckWithAnswer[] = [];
  //     for (
  //       let index = 0;
  //       // index < vehicleDataWithSafetyCheck.safetyCheckDetails.length;
  //       index < exampleSafetyCheckList.length;
  //       index++
  //     ) {
  //       // const questionAnswerObject =
  //       //   vehicleDataWithSafetyCheck.safetyCheckDetails[index];
  //       const questionAnswerObject = exampleSafetyCheckList[index];
  //       safetyCheckDataAnswers.push({
  //         ...questionAnswerObject,
  //         answer: questionAnswerObject?.answer
  //           ? switchAnswerValue(questionAnswerObject?.answer as TYesOrNo)
  //           : undefined,
  //       });
  //     }
  //     setInitialValues({ data: safetyCheckDataAnswers });
  //   }, []);
  React.useEffect(() => {
    if (
      !isLoading &&
      vehicleDataWithSafetyCheck &&
      vehicleDataWithSafetyCheck.safetyCheckDetails
    ) {
      let safetyCheckDataAnswers: ASafetyCheckWithAnswer[] = [];
      for (
        let index = 0;
        index < vehicleDataWithSafetyCheck.safetyCheckDetails.length;
        // index < exampleSafetyCheckList.length;
        index++
      ) {
        // const questionAnswerObject =
        //   vehicleDataWithSafetyCheck.safetyCheckDetails[index];
        const questionAnswerObject =
          vehicleDataWithSafetyCheck.safetyCheckDetails[index];
        safetyCheckDataAnswers.push({
          ...questionAnswerObject,
          answer: questionAnswerObject?.answer
            ? switchAnswerValue(questionAnswerObject?.answer as TYesOrNo)
            : undefined,
        });
      }
      setInitialValues({ data: safetyCheckDataAnswers });
    }
  }, [isLoading]);
  const questionList = generateQuestionAnswerSafetyCheckArray(
    initialValues.data
  );

  return (
    <PageContainer
      headerNavigationContent={
        <Header
          backButtonOnClick={() => {
            navigate(-1);
          }}
          showBackButton={true}
          title={"Daftar Cek Kendaraan"}
        />
      }
      withBackground
      mainContainerStyle={{
        padding: "16px 0 72px 0",
        minHeight: "100vh",
      }}
    >
      <ChecklistQuestionAnswerComponent
        initialValues={initialValues}
        questionsList={questionList}
        showSubmitCheck={false}
        loading={loading}
        /**
         * @todo refactor soon onSubmit
         */
        onSubmit={() => {}}
        isDisabledRadio
        renderButton={
          <button
            className={[btnClasses.button, "outline", "full-width"].join(" ")}
            type="button"
            style={{ height: 48, fontSize: 12 }}
            onClick={() =>
              navigate(
                role === "FSO"
                  ? `${combinedRoutes.admin}`
                  : `${combinedRoutes.guest}`
              )
            }
          >
            <span>KEMBALI KE HALAMAN UTAMA</span>
          </button>
        }
      />
    </PageContainer>
  );
};

export default SafetyChecklistInactivePage;
